import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../api";
import { ClearAllCache } from "../../cache";
import { PrimaryButton } from "../../components/button";
import { FormControl } from "../../components/form";
import { Icon } from "../../components/icon";
import { ExternalLink } from "../../components/link";
import { TotpCodeInput } from "../../components/totp-code-input";
import { getPendingOAuthPath, putSession } from "../../session";
import { runOperation } from "../../ui/operation";
import { LoginLayout } from "./login-layout";

const supportUrl = "https://aivax.net/contact/";

export default function (ctx) {
    const status = el.state.create("loading");
    const token = ctx.query.token;
    let codeInput;

    function complete(result) {
        ClearAllCache();
        putSession({
            sessionKey: result.data.accessToken,
            data: result.data.account
        });
        window.location.assign(getPendingOAuthPath() || "/dashboard");
    }

    async function exchange(totpCode) {
        const result = await api.postJson("/api/v1/auth/recovery/sign-in", {
            token,
            totpCode
        }, {
            handleUnauthorized: false,
            suppressError: !totpCode
        });

        if (result?.data?.accessToken) {
            complete(result);
            return;
        }

        if (result?.data?.requiresTwoFactor) {
            status.value = "code";
            return;
        }

        status.value = "error";
    }

    return LoginLayout(
        el("div.login-form",
            {
                mount() {
                    if (!token) {
                        status.value = "error";
                        return;
                    }

                    exchange().catch(() => {
                        status.value = "error";
                    });
                }
            },
            el("header.login-form-header",
                el("h1", "Sign in once"),
                el("p", "This link signs you in without your login key. It can be used once.")
            ),
            el.state.listening([status], () => {
                if (status.value === "loading") {
                    return el("div.login-form-message", { "aria-live": "polite" }, "Checking your sign-in link...");
                }

                if (status.value === "code") {
                    codeInput = TotpCodeInput({ autofocus: true });
                    return el("form", {
                        onSubmit(event) {
                            event.preventDefault();
                            const code = codeInput.value;
                            if (!/^\d{6}$/.test(code)) return;
                            runOperation("Checking code...", () => exchange(code));
                        }
                    },
                        FormControl("Authentication code", codeInput),
                        PrimaryButton(
                            el("span", "Verify"),
                            Icon("arrow-right-line"),
                            { classList: ["login-submit"], type: "submit" }
                        )
                    );
                }

                return el("div.login-form-message.error",
                    { "aria-live": "polite" },
                    Icon("error-warning-line"),
                    "This sign-in link is invalid or has expired."
                );
            }),
            ExternalLink("Contact support", supportUrl, { rel: "noreferrer" }),
            el("div.login-register-row",
                el("a.app-link[href='/login']", "Back to sign in", {
                    onClick(event) {
                        event.preventDefault();
                        page("/login");
                    }
                })
            )
        )
    );
}
